<form class="gap-lg grid" [formGroup]="form">
  <div hlmField>
    <label hlmFieldLabel for="select-aptitude">Rattacher à l'aptitude</label>
    <hlm-select class="inline-block" placeholder="Sélectionnez une aptitude" formControlName="aptitude">
      <hlm-select-trigger id="select-aptitude">
        <hlm-select-value />
      </hlm-select-trigger>
      <hlm-select-content>
        @for (aptitude of aptitudes(); track aptitude.id) {
          <hlm-option [value]="aptitude.id">
            {{ aptitude.nom }}
          </hlm-option>
        }
      </hlm-select-content>
    </hlm-select>
  </div>

  <div hlmField>
    <label for="input-nom" hlmFieldLabel labelRequired>Nom de la production</label>
    <input id="input-nom" hlmInput type="text" formControlName="nom" />
    @if (nom.hasError('required')) {
      <hlm-field-error>Merci de renseigner un nom</hlm-field-error>
    }
    @if (nom.hasError('notUnique')) {
      <hlm-field-error>Cette production existe déjà</hlm-field-error>
    }
  </div>
</form>
